import { getUserAgent, ServerRequest } from './ua';
import { DEVICE_REG } from '@/constants/deviceReg';
import { UAParser } from 'ua-parser-js';

/**
 * 检查用户代理字符串是否为百度 App
 * @param {string} ua - 用户代理（User Agent）字符串
 * @returns {boolean} - 如果是百度 App 则返回 true，否则返回 false
 */
export function isInBaiduApp(ua: string): boolean {
  return DEVICE_REG.BAIDU_APP.test(ua);
}

/**
 * 检查是否为遥控器设备
 * @param {ServerRequest} [req] - 请求对象
 * @returns {boolean} - 如果是遥控器则返回 true，否则返回 false
 */
export function checkIsRC(req?: ServerRequest): boolean {
  const userAgent = getUserAgent(req);
  return DEVICE_REG.RC.test(userAgent);
}

/**
 * 基于 UA 判断是否为移动设备
 * 除 ua-parser 结果外，补一条 Android 手机兜底：部分机型（如 PLK110）会被误判为 LG 平板
 */
function isMobileByParser(userAgent: string): boolean {
  const { device } = UAParser(userAgent);
  return device.is('mobile') || DEVICE_REG.ANDROID_MOBILE.test(userAgent);
}

/**
 * 检查服务端环境下是否为移动设备
 */
function checkServerMobile(req: ServerRequest): boolean {
  // 如果是遥控器，直接返回 true 走 mobile
  if (checkIsRC(req)) return true;
  return isMobileByParser(getUserAgent(req));
}

/**
 * 检查客户端环境下是否为移动设备
 */
function checkClientMobile(): boolean {
  // 如果是遥控器，直接返回 true 走 mobile
  if (checkIsRC()) return true;
  return isMobileByParser(getUserAgent());
}

/**
 * 检查是否为移动设备
 * @param {ServerRequest} [req] - 服务端请求对象
 * @returns {boolean} - 如果是移动设备则返回 true，否则返回 false
 */
export function checkIsMobile(req?: ServerRequest): boolean {
  return req ? checkServerMobile(req) : checkClientMobile();
}

// 判断代码是否在服务端运行
export function isServer() {
  return typeof window === 'undefined';
}

export const isRC: boolean = checkIsRC();
export const isMobile: boolean = checkIsMobile();

type Platform = 'm' | 'pc';
export const platform: Platform = isMobile ? 'm' : 'pc';

